export default "__VITE_ASSET__25mTy$YS__"